(ns frontend.view.settings2.web-form.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce webentry-state (r/cursor db/app-state [:views :settings :webentry]))
(defonce modal-field-settings (r/cursor webentry-state [:modal-field-settings]))
